/** Normalises stored HTML before react-native-render-html (shared by HtmlText). */
export function prepareHtmlContent(content: string, wrapPlainTextInParagraph = true): string {
  const cleanedContent = content.replace(/<br\/>/g, '');
  if (!wrapPlainTextInParagraph) {
    return cleanedContent;
  }
  return content.startsWith('<p') ? cleanedContent : `<p>${cleanedContent}</p>`;
}
